<template>
  <div class="approval-progress-query">
    <div class="query-entry" @click="openModal">
      <div class="query-entry-icon">
        <svg viewBox="0 0 24 24" width="28" height="28" fill="none">
          <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
          <path d="M20 20L16.5 16.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div class="query-entry-text">
        <div class="query-entry-title">查询审批进度</div>
        <div class="query-entry-desc">已提交申请？输入手机号即可查看是否审批通过</div>
      </div>
      <div class="query-entry-btn">立即查询</div>
    </div>

    <Modal :visible="visible" appendBody>
      <div class="progress-modal">
        <div class="progress-modal-header">
          <span>{{ modalTitle }}</span>
          <i class="close" @click="closeModal"></i>
        </div>
        <div class="progress-modal-body">
          <div class="phone-field">
            <label>手机号码</label>
            <input
              v-model="phone"
              type="tel"
              maxlength="11"
              placeholder="请输入申请时填写的手机号"
              @keyup.enter="handleQuery"
            />
          </div>
          <button class="query-btn" :disabled="loading" @click="handleQuery">
            {{ loading ? '查询中...' : '查询进度' }}
          </button>

          <div v-if="result" class="result-panel" :class="resultClass">
            <div class="result-status">
              <span class="status-dot"></span>
              {{ result.approvalStatusText }}
            </div>
            <div class="result-name" v-if="result.memName">{{ nameLabel }}：{{ result.memName }}</div>
            <div class="result-phone">手机号：{{ result.phone }}</div>

            <div class="result-message" v-if="result.approvalStatus === '101'">
              您的申请正在审批中，我们将于3个工作日内尽快完成审批，请耐心等待。
            </div>
            <div class="result-message success" v-else-if="result.approvalStatus === '200'">
              恭喜，您的申请已审批通过！初始登录账号为手机号，密码为 <strong>123456</strong>，请尽快登录并修改密码。
            </div>
            <div class="result-message error" v-else-if="result.approvalStatus === '102'">
              很抱歉，您的申请未通过审批。
              <span v-if="result.approvalRemarks">审批意见：{{ result.approvalRemarks }}</span>
            </div>

            <button
              v-if="result.approvalStatus === '200'"
              class="login-btn"
              @click="goLogin"
            >
              立即登录 →
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal.vue';
import { queryApprovalProgress } from '../service/api';

export default {
  name: 'ApprovalProgressQuery',
  components: {
    Modal,
  },
  props: {
    memType: {
      type: String,
      default: 'personal',
    },
  },
  data() {
    return {
      visible: false,
      phone: '',
      loading: false,
      result: null,
    };
  },
  computed: {
    isOrg() {
      return this.memType === 'org';
    },
    modalTitle() {
      return this.isOrg ? '团体会员审批进度查询' : '个人会员审批进度查询';
    },
    nameLabel() {
      return this.isOrg ? '单位名称' : '申请人';
    },
    resultClass() {
      if (!this.result) {
        return '';
      }
      if (this.result.approvalStatus === '200') {
        return 'is-success';
      }
      if (this.result.approvalStatus === '102') {
        return 'is-error';
      }
      return 'is-pending';
    },
  },
  methods: {
    openModal() {
      this.visible = true;
      this.result = null;
    },
    closeModal() {
      this.visible = false;
      this.loading = false;
    },
    validatePhone() {
      const value = (this.phone || '').trim();
      if (!value) {
        this.$message({ type: 'error', content: '请输入手机号' });
        return false;
      }
      if (!/^1\d{10}$/.test(value)) {
        this.$message({ type: 'error', content: '请输入正确的11位手机号' });
        return false;
      }
      return true;
    },
    handleQuery() {
      if (!this.validatePhone()) {
        return;
      }
      this.loading = true;
      this.result = null;
      queryApprovalProgress({ phone: this.phone.trim(), memType: this.memType })
        .then((data) => {
          this.result = data;
        })
        .catch((err) => {
          this.$message({ type: 'error', content: err || '查询失败' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="less" scoped>
.approval-progress-query {
  margin-bottom: 24px;
}

.query-entry {
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 20px 28px;
  border-radius: 14px;
  background: #fff;
  border: 1px solid rgba(255, 255, 255, 0.9);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(6, 174, 99, 0.15);
  }
}

.query-entry-icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e8faf2 0%, #d4f5e4 100%);
  color: #06ae63;
  display: flex;
  align-items: center;
  justify-content: center;
}

.query-entry-text {
  flex: 1;
  min-width: 0;
}

.query-entry-title {
  font-size: 20px;
  font-weight: 600;
  color: #131415;
  line-height: 28px;
}

.query-entry-desc {
  margin-top: 4px;
  font-size: 14px;
  color: #6b7280;
  line-height: 22px;
}

.query-entry-btn {
  flex-shrink: 0;
  padding: 11px 24px;
  border-radius: 24px;
  background: linear-gradient(135deg, #06ae63 0%, #0bc978 100%);
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(6, 174, 99, 0.35);
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  .query-entry:hover & {
    box-shadow: 0 6px 18px rgba(6, 174, 99, 0.45);
  }
}

.progress-modal {
  width: 520px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.progress-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid #f0f0f0;
  font-size: 18px;
  font-weight: 600;
  color: #131415;

  .close {
    width: 20px;
    height: 20px;
    cursor: pointer;
    background: url(../../../assets/images/icon-close.png) no-repeat center;
    background-size: contain;
  }
}

.progress-modal-body {
  padding: 24px;
}

.phone-field {
  label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    color: #4e5969;
  }

  input {
    width: 100%;
    height: 44px;
    padding: 0 14px;
    border: 1px solid #e5e6eb;
    border-radius: 8px;
    font-size: 15px;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #06ae63;
      box-shadow: 0 0 0 2px rgba(6, 174, 99, 0.12);
    }
  }
}

.query-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  margin-top: 16px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #06ae63 0%, #0bc978 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(6, 174, 99, 0.3);
  transition: box-shadow 0.2s ease, opacity 0.2s ease;

  &:hover:not(:disabled) {
    box-shadow: 0 6px 16px rgba(6, 174, 99, 0.4);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    box-shadow: none;
  }
}

.result-panel {
  margin-top: 20px;
  padding: 18px;
  border-radius: 10px;
  background: #f7f8fa;

  &.is-pending {
    background: #fff7e8;
    .status-dot { background: #ff7d00; }
  }

  &.is-success {
    background: #e8fff3;
    .status-dot { background: #06ae63; }
  }

  &.is-error {
    background: #fff1f0;
    .status-dot { background: #f53f3f; }
  }
}

.result-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 600;
  color: #131415;
}

.status-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.result-name,
.result-phone {
  margin-top: 8px;
  font-size: 14px;
  color: #4e5969;
}

.result-message {
  margin-top: 12px;
  font-size: 14px;
  line-height: 24px;
  color: #4e5969;

  strong {
    color: #06ae63;
    font-size: 16px;
  }
}

.login-btn {
  width: 100%;
  height: 42px;
  margin-top: 16px;
  border: 1px solid #06ae63;
  border-radius: 8px;
  background: #fff;
  color: #06ae63;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: #f0fdf6;
  }
}
</style>
